import React from 'react';
import { ScrollText, Package, Handshake, School, 
  GraduationCap, Users,
  LayoutGrid,
  Medal,
  Telescope,
  User,
  FolderSync,
  CircleHelp,
  
  Boxes, TicketCheck, Citrus, Car, Trophy, TrafficCone, ShoppingBasket, SquareKanban, BookOpen,BookCheck, Book } from 'lucide-react';
import { title } from 'process';
import { Rocket } from '@mui/icons-material';
import SchoolIcon from "@mui/icons-material/School"
import HomeIcon from "@mui/icons-material/Home"

export interface ISidebarItem {
  title: string;
  icon?: React.ReactNode;
  children?: ISidebarItem[];
  selected?: boolean;
  expanded: boolean;
  level?: number;
  id?: number;
  link?: string;
  parent?: ISidebarItem;
  hasChildren: boolean;
}

export const pageRoutes: ISidebarItem[] = [
  {
    title: 'Dashboard',
    link: `/${process.env.PREFIX}/dashboard`,
    icon: <HomeIcon />,
    children: []
  },
  // {
  //   title: 'My Courses',
  //   icon: <BookOpen />,
  //   link: `/${process.env.PREFIX}/my-courses`,
  //   children: []
  // },
  {
    title:"My ThoughtCoCreate",
    icon: <SchoolIcon />,
    link: `/${process.env.PREFIX}/my-thoughtcocreate`,
    children: [
      {
        title: "Dashboard",
        link: `/${process.env.PREFIX}/my-thoughtcocreate/dashboard`,
      },
      {
        title: "Deliverable 1",
        link: `/${process.env.PREFIX}/my-thoughtcocreate/deliverable/1`,
      },{
        title: "Deliverable 2",
        link: `/${process.env.PREFIX}/my-thoughtcocreate/deliverable/2`,
      },{
        title: "Deliverable 3",
        link: `/${process.env.PREFIX}/my-thoughtcocreate/deliverable/3`,
      },{
        title: "Deliverable 4",
        link: `/${process.env.PREFIX}/my-thoughtcocreate/deliverable/4`,
      }
    ]
  },
  // {
  //   title:"Learning",
  //   icon: <SchoolIcon />,
  //   children: [
  //     // {
  //     //   title: "My Courses",
  //     //   link: `/${process.env.PREFIX}/my-courses`,
  //     // },
  //     // {
  //     //   title: "My Contests",
  //     //   link: `/${process.env.PREFIX}/my-contests`,
  //     // },
  //     {
  //       title: "My ThoughtCoCreate",
  //       link: `/${process.env.PREFIX}/my-thoughtcocreate`,
  //     },
  //     // {
  //     //   title: "Achievements & Badges",
  //     //   link: `/${process.env.PREFIX}/achievements`,
  //     // }
  //   ]
  // },
  {
    title:"Tools",
    link: `/${process.env.PREFIX}/my-learning-tools`,
    children: [{
      title: "Learning Tools",
      link: `/${process.env.PREFIX}/my-learning-tools`,
    },{
      title: "My Twinspace",
      link: `/${process.env.PREFIX}/my-twinspace`,
    }],
    icon: <Telescope />
  },
  {
    title:"My Profile",   
    icon: <User />,
    link: `/${process.env.PREFIX}/my-profile`,
  },
  {
    title:"Help",
    icon: <CircleHelp />,
    link: `${process.env.URL_HELP}`,
  },
  {
    id:1000,
    title: 'Switch workspace',
    icon: <FolderSync />,
    children: [{}]
  },
] as any;

var counter = 0;

const setLevelDepth = (item: ISidebarItem, level: number, parent?: ISidebarItem) => {
  item.level = level;
  item.hasChildren = false;
  item.expanded = false;
  item.id = counter++;
  if (parent) {
    item.parent = parent;
  }
  if (item.children && item.children.length > 0) {
    item.hasChildren = true;
    item.children.forEach(child => setLevelDepth(child, level + 1, item));
  }
}

pageRoutes.forEach(item => setLevelDepth(item, 0));